import React from 'react';
import ShowContainer from './showContainer';
import '../App.css';


const projects = [
  {
    name: 'Quatta',
    image: null,
    type: 'Fintech Mobile App',
    stack: ['Flutter', 'Stripe', 'Finance APIs'],
    outcome: 'Live on App Store and Google Play',
    description: 'A gamified finance app with a money health score, daily savings and debt missions, live stock data, and an income calculator.',
    links: [
      { label: 'App Store', url: 'https://apps.apple.com/us/app/quatta/id6755897717' },
      { label: 'Google Play', url: 'https://play.google.com/store/apps/details?id=com.quatta.app' },
    ],
  },
  {
    name: 'Dawnce',
    image: null,
    type: 'Consumer Mobile App',
    stack: ['Flutter', 'Google ML Kit', 'RevenueCat'],
    outcome: 'Shipped with motion-verification alarm dismissal',
    description: 'An alarm application that uses pose detection to verify dance moves before dismissal, including production billing flows with RevenueCat.',
    link: 'https://apps.apple.com/ph/app/dawnce/id6760565547'
  },
  {
    name: 'Altrhouse',
    image: null,
    type: '3D Fashion Visualizer',
    stack: ['Flutter', 'Caching', 'Draco Compression'],
    outcome: 'Near-instant mannequin preview switching',
    description: 'Led frontend architecture and implemented neighbor-loading cache strategies across multiple 3D garment combinations.',
    link: 'https://altrhouse.com/'
  },
  {
    name: 'Sharecase',
    image: null,
    type: 'Mentorship Platform',
    stack: ['Node.js', 'PostgreSQL', 'API Optimization'],
    outcome: 'Average API response time cut from 20s to under 1s',
    description: 'Reworked backend architecture by removing redundant calls, restructuring schema design, and rewriting slow database queries.',
    link: 'https://joinsharecase.com/'
  },
  {
    name: 'Raale',
    image: null,
    type: 'AI Dating Platform',
    stack: ['Real-time Chat', 'AWS Verification', 'Moderation'],
    outcome: 'Added trust and safety-critical features',
    description: 'Built live messaging, AWS liveness and face verification, and moderation tools for safer user interactions.',
    link: 'https://github.com/abduvert'
  },
  {
    name: 'AiCenna',
    image: '/assets/aicenna.gif',
    type: 'Healthcare Platform',
    stack: ['Flutter', 'Riverpod', 'Next.js'],
    outcome: 'Improved initial screen load by 30%',
    description: 'Delivered mobile, web, and admin experiences with responsive UI, localization, caching, and dashboard tooling.',
    link: 'https://aicenna.com'
  },
  {
    name: 'U.n.I',
    image: '/assets/uni.jpg',
    type: 'Social AI App',
    stack: ['Flutter', 'Riverpod', 'Django'],
    outcome: 'Reduced render time by 20% and UI crashes by 15%',
    description: 'A social-AI mobile application built with Flutter and Riverpod, focused on meaningful connections, performance optimization, and scalable interaction flows.',
    link: 'https://play.google.com/store/apps/details?id=com.HBMStudios.U.n.I'
  },
  {
    name: 'Cirkles',
    image: '/assets/cirkles.svg',
    type: 'Web App',
    stack: ['Next.js', 'Maps', 'Recommendation Features'],
    outcome: 'Improved navigation clarity and interaction efficiency',
    description: 'A web platform built with Next.js featuring event discovery, AI-based recommendations, and map-driven activity exploration.',
    link: 'https://www.cirkles.space/'
  },
  {
    name: 'Ai-Bay',
    image: '/assets/aibay.jpeg',
    type: 'Service Marketplace',
    stack: ['React', 'Real-time Chat', 'Auth'],
    description: 'An AI-powered service marketplace with authentication, real-time chat, bookings, and contract workflows, designed for modern freelance and service platforms.',
    link: 'https://admin-panel-admin-panel-team.vercel.app/'
  },
  {
    name: 'Mood Sync',
    image: '/assets/moodsync.jpeg',
    description: 'A hackathon project built in 24 hours — an AI-powered personal assistant offering mood-based recommendations, task parsing, daily summaries, heatmaps, and OCR-based notes.',
    link: 'https://github.com/TheNullPointerrs/SOFTEC-APP'
  },
  {
    name: 'GymVisa',
    image: '/assets/gymvisa.jpg',
    type: 'Fitness Subscription App',
    stack: ['Flutter', 'Firebase', 'Mobile Payments'],
    description: 'A Flutter-based mobile app with a Firebase backend. Offers access to multiple gyms under various subscription packages, in-app payments, offline exercise videos, and diet plans from nutritionists.',
    link: 'https://github.com/abduvert/GYMVISA/tree/main'
  },
  {
    name: 'Moods Ayah',
    image: '/assets/moodsayah.jpg',
    description: 'Discover Ayahs based on your chosen mood. Using React\'s state management and fetching data from the created API using Axios. The collection is small for now, but plenty more to come! 🌱📖',
    link: 'https://moodsayah.netlify.app'
  },
  {
    name: 'Class Insights',
    image: '/assets/ClassInsights (2).png',
    type: 'School Management App',
    stack: ['Flutter', 'Admin Workflows', 'Education'],
    description: 'A powerful and intuitive school management app built with Flutter, designed to streamline the educational process for administrators, teachers, students, and parents. Ensures efficient management and communication within the school community.',
    link: 'https://github.com/IMUSARAZA/ClassInsight'
  },
  {
    name: 'GymVisa Web',
    image: '/assets/gm web.PNG',
    description: 'GymVisa Web is a website built for the marketing of their mobile application, GymVisa.',
    link: 'https://gymvisa.co/'
  },
  {
    name: 'Scriptly AI',
    image: '/assets/sc3.PNG',
    type: 'Creator Tooling',
    stack: ['Next.js', 'LLM APIs', 'Analytics'],
    description: 'This project built with NextJS uses AI (LLM) to create custom, multilingual scripts that align with a creator’s voice, provide trending topic suggestions, and offer monetization tips. It includes real-time viewer insights and repurposes content for platforms like TikTok, Instagram Reels, and podcasts, helping creators grow and engage audiences globally.',
    link: 'https://scriptly-ai.vercel.app/'
  },
  {
    name: 'CodeFlash AI',
    image: '/assets/codef.PNG',
    type: 'Learning Platform',
    stack: ['Next.js', 'Groq AI', 'Active Recall'],
    description: 'A project built with NextJS and GroqAi to transform your coding with CodeFlash—engaging flashcards for AI learners and CS students. Master new languages and concepts with active recall and avoid tutorial hell. Make learning interactive and fun!',
    link: 'https://codeflash.vercel.app/'
  },
  {
    name: 'Buzzats',
    image: '/assets/buzzats.PNG',
    type: 'Campus Social App',
    stack: ['Flutter', 'Student Services', 'Scheduling'],
    description: 'A socializing mobile application designed to foster connections among students enrolled at Comsats University Islamabad, Lahore campus. It enables students to interact, access timetables, check room availability, and seek assistance with campus-related challenges.',
    link: 'https://github.com/IbraheemHaseeb7/buzzats'
  },
  {
    name: 'Cart Quest',
    image: '/assets/cartquest.PNG',
    description: 'Built my first website, incorporating routes, API calls, models, session and cookie-based work, and authentication. This mastery has exponentially broadened my web development skills.',
    link: 'https://github.com/abduvert/WEBTECH/tree/master/project'
  },
  {
    name: 'UniBuddy AI',
    image: '/assets/chat.PNG',
    description: 'A chatbot designed especially for any student to get any university\'s information just by asking it',
    link: 'https://unibuddy-ai.vercel.app/'
  },

];


const Projects = () => {
  return (
    <div className='projects'>
      {projects.map((project, index) => (
        <ShowContainer key={index} project={project} />
      ))}
    </div>
  );
};

export default Projects;
